module.exports = __webpack_public_path__ + "static/img/pic_szh_cgal_ny_bg.615ed068.png";